import { render, staticRenderFns } from "./datasetmodal.vue?vue&type=template&id=17bdde48&scoped=true"
import script from "./datasetmodal.vue?vue&type=script&lang=js"
export * from "./datasetmodal.vue?vue&type=script&lang=js"
import style0 from "./datasetmodal.vue?vue&type=style&index=0&id=17bdde48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bdde48",
  null
  
)

export default component.exports